import { CSSProperties, MouseEvent, useContext, useEffect, useState } from "react";
import { AlertApi } from "../../../redux/api/AlertApi";
import { IAlert } from "../../../types/Alert/IAlert";
import { IUserProfile } from "../../../types/User/IUserProfile";
import { RevUserContext } from "../../../context/UserContext";

// const sampleNotifications = [
//   "notification 1",
//   "notification 2 medium medium medium medium medium medium medium medium medium medium medium medium length notification",
//   "notification 3 very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very very long notification",
// ];

export interface INotificationsProps {
  navColor: string;
}

export const Notifications = ({ props }: { props: INotificationsProps }) => {
  const profile = useContext<IUserProfile>(RevUserContext);
  const { navColor } = props;
  const [notifications, setNotifications] = useState<IAlert[]>([]);
  const [showNotification, setShowNotification] = useState(0);
  const { data: alertConfig } = AlertApi.useGetAlertConfigQuery(undefined, { skip: profile.Features?.External_Interface });

  useEffect(() => {
    //Fetch alerts from webservice
    if (alertConfig) {
      fetch(alertConfig.Alerts_Get_Url).then((data) => {
        if (data.ok)
          return data.json()
      }).catch((err) => console.warn(err)).then((data) => {
        console.log('data', data);
        setNotifications(data)

        //Mark the first message as seen
        if (data?.length > 0) {
          seen(data.at(0).uid);
        }
      });
    }
    return () => {

    }
  }, [alertConfig])


  const notificationStyle: CSSProperties = {
    backgroundColor: navColor,
    borderTop: "solid 2px white",
    borderRight: "solid 2px white",
    borderLeft: "solid 2px white",
    display: "flex",
    placeContent: "space-between",
    color: "white",
    boxShadow: "5px 5px 4px 0px rgba(0,0,0,0.03)",
  };
  function handleRemoveNotification(event: MouseEvent<HTMLButtonElement>) {
    //Post to the API that the message has been closed.
    if (alertConfig) {
      var messageId = event.currentTarget.getAttribute("data-uid")
      fetch(alertConfig.Read_Post_Url.replace('{AlertUid}', messageId), {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          "ClientInfoEncrypted": alertConfig.ClientInfoEncrypted
        })
      }).then(() => {
        //Remove the message
        setNotifications((note) => note.filter((f) => f.uid !== messageId))

        //Back to message 1
        setShowNotification(0);
      });
    }
  }
  //Marks the notifcation as 'Seen'
  async function seen(messageId) {
    return fetch(alertConfig.Seen_Post_Url.replace('{AlertUid}', messageId), {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        "ClientInfoEncrypted": alertConfig.ClientInfoEncrypted
      })
    });
  }
  function handleNotificationIteration(event: MouseEvent<HTMLButtonElement>) {
    const workingIndex = parseInt(
      event.currentTarget.getAttribute("data-index")
    );
    const calculatedIndex = workingIndex % notifications.length;
    console.log("calculatedIndex", calculatedIndex);
    setShowNotification(calculatedIndex);

    //Mark the message as seen
    if (notifications.length > calculatedIndex) {
      var messageId = notifications.at(calculatedIndex).uid
      seen(messageId);
    }
  }


  return (
    <>
      {notifications?.length > 0 && (
        <ul className="relative z-[100]">
          <li style={notificationStyle} className="alert-item">
            <div className="flex">
              <div className="bg-black w-[50px] min-w-[50px] mr-2">
                <span className="flex place-content-center text-xs  pt-1">
                  {showNotification >= 0
                    ? Math.abs(showNotification) + 1
                    : showNotification + notifications.length + 1}{" "}
                  of {notifications.length}
                </span>
                <div className="flex place-content-center h-full">
                  <button
                    className="flex flex-grow place-content-end pr-2 pt-2 pb-1 hover:animate-pulse"
                    onClick={handleNotificationIteration}
                    data-index={showNotification - 1}
                  >
                    <img
                      src="./images/img_arrow_left.png"
                      alt="previous notification"
                    />
                  </button>
                  <button
                    className="flex flex-grow pl-2 pt-2 pb-2 hover:animate-pulse"
                    onClick={handleNotificationIteration}
                    data-index={showNotification + 1}
                  >
                    <img
                      src="./images/img_arrow_right.png"
                      alt="next notification"
                    />
                  </button>
                </div>
              </div>
              <span className="grid place-content-center">
                {notifications.length >= showNotification && <div dangerouslySetInnerHTML={{ __html: notifications.at(showNotification).message }} ></div>}
              </span>
            </div>
            <button
              className="pl-1 pr-5 hover:animate-pulse"
              data-uid={notifications.at(showNotification).uid}
              onClick={handleRemoveNotification}
            >
              <img
                className="w-[15px] min-w-[15px]"
                src={"./images/img-cancel.png"}
                alt="close"
              />
            </button>
          </li>
        </ul>
      )}
    </>
  );
};
